module.exports = __webpack_public_path__ + "static/media/logo-optimized.de670954.png";